import { createAchDepositAsync } from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSlice } from '../../../../createAsyncSlice';

export const { slice: createAchDepositSlice, asyncAction: createAchDepositAction } = createAsyncSlice(
  'createAchDepositSlice',
  createAchDepositAsync
);
